<template>
<PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition', 'pa-connection-add-cofirm-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .15}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
  >
    <PaWideModalBox
     :confirmButtonText="buttonText"
     :isSubmitLoading="isSubmitLoading"

     @handleSubmit="handleClickSubmitButton"
     @handleCancel="handleClickCancelButton"
    >
      <template v-slot:title>{{title}}</template>
      <template v-slot:description>{{description}}</template>
      <template v-slot:caption>{{caption}}</template>
      <template v-slot:messageTitle><span class="bold">―</span>&nbsp;御注意事項&nbsp;<span class="bold">―</span></template>
      <template v-slot:message>{{message}}</template>
    </PaWideModalBox>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PaWideModalBox from '@/components/Parts/PAWideModalBox/PAWideModalBox.vue'

import {GetParkData} from '@/graphql/queries/Park.graphql'

export default {
  props : {
    parkId : {
      default: null
    },

    isOpenModal : {
      default: false
    },

    isSubmitLoading : {
      default: false
    },
  },

  components : {
    PaOverlayModal,
    PaWideModalBox
  },

  data(){
    return {
      isFreezModal    : false,
      title           : 'クリップを解除する',
      description     : "ひろば「[[name]]」のクリップを解除します。よろしいですか？",
      caption         : '解除するために消費されるアイテムはありません。',
      message         : '一度解除を行うと、再度ひろばが見つかるまでクリップを行うことができません。',
      buttonText      : 'クリップを解除する',
    };
  },

  apollo : {
    park : {
      query : GetParkData,
      
      variables(){
        return {
          id : this.parkId
        };
      },

      skip(){
        if(this.parkId === null){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  watch : {
    isSubmitLoading(value){
      this.isFreezModal = value;
    },

    park : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;

        this.updateTextData();
      },
      immediate: true,
      deep: true
    },
  },

  methods : {
    async handleClickSubmitButton(){
      this.$emit('onClickSubmit');
    },

    handleClickCancelButton(){
      this.$emit('onClickCancel');
    },

    handleCloseOverlay(){
      this.$emit('onCloseOverlay');
    },

    updateTextData(){
      this.title        = this.textReplacer(this.title, this.park);
      this.description  = this.textReplacer(this.description, this.park);
      this.caption      = this.textReplacer(this.caption, this.park);
      this.message      = this.textReplacer(this.message, this.park);
      this.buttonText   = this.textReplacer(this.buttonText, this.park);
    }
  }
}
</script>